



































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { storeDokter } from "@/store/modules/dokter";
import SuketMata from "@/services/SuketMata";
import StoreSuketMata from "@/store/modules/SuketMata";
import { SuketMataInterface } from "@/types/suket_mata";
import { getAge, formatDMYDate } from "@/utility/DateUtils";

@Component({
  components: {
    CardModalTtd,
  },
  inject: { isReadOnly: { default: () => () => false } },
})
export default class CardInputSKMata extends Vue {
  @Prop() readonly register!: string;
  @Prop() readonly recordValue!: SuketMataInterface | null;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  register_id = this.recordValue?.register_id || this.register;
  pasien_rm = this.recordValue?.pasien_rm || this.statePasien.rm;
  nama = this.recordValue?.nama || this.statePasien.nama;
  umur =
    this.recordValue?.umur ||
    getAge(formatDMYDate(this.statePasien.tgl_lahir)).toString().concat(" Th");
  sex = this.recordValue?.sex || this.statePasien.jk.substring(0, 1);
  pekerjaan = this.recordValue?.pekerjaan || this.statePasien.pekerjaan;
  alamat = this.recordValue?.alamat || this.statePasien.alamat;
  exam_result = this.recordValue?.exam_result || {
    mata_sehat: true,
    vod: null,
    vos: null,
    tak_buta_warna: true,
  };
  kesimpulan = this.recordValue?.kesimpulan || "";
  kegunaan = this.recordValue?.kegunaan || "";
  exam_date = this.recordValue?.exam_date || new Date();
  dr_id = Number(this.recordValue?.dr_id) || this.user.id;
  unit_id = this.recordValue?.unit_id || this.user.unit_id;

  alert = "";
  validasi = [(v) => !!v || "*Kolom ini harus diisi"];
  modal = false;
  saving = false;

  get user() {
    return userModule.user;
  }

  get input() {
    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      nama: this.nama,
      umur: this.umur,
      sex: this.sex,
      pekerjaan: this.pekerjaan,
      alamat: this.alamat,
      exam_result: this.exam_result,
      kesimpulan: this.kesimpulan,
      kegunaan: this.kegunaan,
      exam_date: this.exam_date,
      dr_id: this.dr_id,
      unit_id: this.unit_id,
    };
  }

  get statePasien() {
    return storePasien.identitasPasien;
  }

  get listDokter() {
    return storeDokter.list;
  }

  get examCategory() {
    return StoreSuketMata.examInputCategory;
  }

  passTtd(value) {
    this.$emit("passTtd", value);
    // this.modal = false;
  }

  save() {
    if (this.readOnly) return;
    if (!this.saving) {
      this.saving = true;

      const action = this.recordValue
        ? SuketMata.update(this.recordValue.id, this.input)
        : SuketMata.create(this.input);

      action
        .then(() => {
          this.$emit("showSignatureModal");

          appModule.NoticeDelay("Berhasil Simpan Surat Keterangan Mata");

          this.close();
          StoreSuketMata.getSuketByRegister(this.register);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  close() {
    this.$emit("close");
  }
}
